import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { MouseEvent, useContext } from 'react';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { UserActivityLayoutContext } from '../userActivityLayoutContext';

import styles from './conversationPreviewButton.module.scss';

type ConversationPreviewButtonProps = {
  /** The id of the conversation to preview. */
  readonly conversationId: string;
};

/** Opens the conversation preview modal. */
export const ConversationPreviewButton = ({
  conversationId,
}: ConversationPreviewButtonProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const isCompact = useContext(UserActivityLayoutContext) === 'compact';

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:conversationPreview',
          arg: { csid: Number(conversationId) },
        },
      }),
    );
  };

  return (
    <Tooltip content="Preview">
      <IconButton
        className={classnames(styles.button, {
          [styles.compact]: isCompact,
        })}
        icon="eye"
        iconSize={isCompact ? 12 : 14}
        variant="tertiary"
        aria-label="Preview conversation"
        onClick={handleClick}
      />
    </Tooltip>
  );
};
